import trainingRouteManifest from './trainingRouteManifest.json';

const getSlug = (path) => path.slice(path.lastIndexOf('/') + 1);

const createOffer = ({
  key,
  duration,
  tuition,
  certifications = [],
}) => {
  const registration = 20000;
  const paths = trainingRouteManifest.offers[key];

  return Object.freeze({
    key,
    duration: Object.freeze(duration),
    tuition,
    registration,
    total: tuition + registration,
    intake: '2026-09-15',
    capacity: Object.freeze({ inPerson: 10, online: 20 }),
    certifications: Object.freeze(certifications),
    slugs: Object.freeze({
      fr: getSlug(paths.fr),
      en: getSlug(paths.en),
    }),
  });
};

export const TRAINING_LOCALES = Object.freeze(['fr', 'en']);

export const TRAINING_OFFERS = Object.freeze([
  createOffer({ key: 'essential', duration: { value: 1, unit: 'month' }, tuition: 30000 }),
  createOffer({ key: 'progression', duration: { value: 2, unit: 'month' }, tuition: 60000 }),
  createOffer({ key: 'immersion', duration: { value: 3, unit: 'month' }, tuition: 80000 }),
  createOffer({
    key: 'professional',
    duration: { value: 6, unit: 'month' },
    tuition: 250000,
    certifications: ['DQP', 'AQP'],
  }),
  createOffer({
    key: 'expert',
    duration: { value: 1, unit: 'year' },
    tuition: 985000,
    certifications: ['DQP', 'AQP', 'Certification internationale'],
  }),
]);

export const getOffer = (key) => TRAINING_OFFERS.find((offer) => offer.key === key);
